function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m482 205.667969v25.269531h-33.730469v-18.445312l-38.097656-47.222657h-27.496094v-51.871093h-87.921875v-25.398438h42.578125v-88h-187.332031v88h42.578125v25.398438h-59.835937v42.378906h-74.929688v61.539062h-27.8125v-34.125h-30v98.25h30v-34.125h27.8125v72.324219h86.214844l37.65625 41.570313h266.585937v-24.3125h33.730469v24.101562h30v-155.332031zm-129.324219-62.269531v51.871093h43.152344l22.441406 27.816407v108.125h-195.691406v-187.8125zm-172.675781-85.398438v-28h127.332031v28zm42.578125 30h42.175781v25.398438h-42.175781zm-134.765625 97.777344h44.929688v103.863281h-44.929688zm74.929688 109.835937v-152.214843h29.835937v185.15625zm285.527343 11.285157v-45.960938h33.730469v45.960938zm0 0"
});

var Svg035Motor = function Svg035Motor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -75 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg035Motor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/035-motor.e8c38fd1.svg";
export { ForwardRef as ReactComponent };